import { I18n } from '@calendly/i18n'

import { DropdownFilter } from './dropdown/dropdown_filter'
import { FilterLayout } from './filter_layout'

export const InviteeEmailSelect = ({ params, onApply, useColumnLayout = false }) => {
  const filterCount = params.invitee_emails.length

  const controlText = filterCount === 0
    ? I18n.t('publisher.dashboard.filters.label.invitee_emails_all')
    : I18n.t('publisher.dashboard.filters.label.invitee_emails', { count: filterCount })

  const applySelectedValues = (values) => {
    onApply({
      ...params,
      invitee_emails: values?.invitee_email_0 || []
    })
  }

  const dropDownParams = params.period === 'upcoming' ? { ...params, period: 'all_time' } : params

  return (
    <FilterLayout
      label={I18n.t('publisher.meetings.filter_modal.invitee_email.label')}
      useColumnLayout={useColumnLayout}
    >
      <DropdownFilter
        name="invitee_email"
        params={dropDownParams}
        showHeader
        showSearchInput
        onApply={applySelectedValues}
        controlText={controlText}
      />
    </FilterLayout>
  )
}
